var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-form",
    {
      ref: "ruleForm",
      attrs: {
        model: _vm.currentComponent,
        rules: _vm.rules,
        "label-width": "100px",
        isNeedRequire: "",
        isNeedTooltip: "",
        "label-position": "top",
        size: "small",
      },
    },
    [
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_questionstem"),
            prop: "content",
            size: "small",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.content,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "content", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "yxt-form-item",
        {
          staticClass: "yxtbiz-ote-edit-ques-option",
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_options"),
            prop: "questionItems",
            size: "small",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-mid wp-100" },
            [
              _c("span", { staticClass: "mr8 width16 text-center" }, [
                _vm._v(" A "),
              ]),
              _c("yxt-input", {
                attrs: { maxlength: 10 },
                on: { input: _vm.inputChange },
                model: {
                  value: _vm.currentComponent.judgeCorrectOptionContent,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.currentComponent,
                      "judgeCorrectOptionContent",
                      $$v
                    )
                  },
                  expression: "currentComponent.judgeCorrectOptionContent",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "yxt-form-item",
        {
          staticClass: "yxtbiz-ote-edit-ques-option",
          attrs: { label: "", prop: "questionItems", size: "small" },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-mid wp-100 mb16" },
            [
              _c("span", { staticClass: "mr8 width16 text-center" }, [
                _vm._v(" B "),
              ]),
              _c("yxt-input", {
                attrs: { maxlength: 10 },
                on: { input: _vm.inputChange },
                model: {
                  value: _vm.currentComponent.judgeWrongOptionContent,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.currentComponent,
                      "judgeWrongOptionContent",
                      $$v
                    )
                  },
                  expression: "currentComponent.judgeWrongOptionContent",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_ote_lbl_itemanswer"),
            size: "small",
            prop: "answer",
          },
        },
        [
          _c(
            "yxt-radio-group",
            {
              on: { change: _vm.changeAnswer },
              model: {
                value: _vm.currentComponent.answer,
                callback: function ($$v) {
                  _vm.$set(_vm.currentComponent, "answer", $$v)
                },
                expression: "currentComponent.answer",
              },
            },
            _vm._l(_vm.currentComponent.questionItems, function (item) {
              return _c(
                "yxt-radio",
                { key: item.id, attrs: { label: item.id } },
                [_vm._v(_vm._s(item.id === 0 ? "B" : "A"))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-form-item",
        {
          attrs: {
            size: "small",
            label: _vm.$t("pc_biz_ote_lbl_quesanalyze"),
            prop: "explainText",
          },
        },
        [
          _c("common-attachment-textfield", {
            attrs: {
              content: _vm.currentComponent.explainText,
              "single-limit": "",
            },
            on: {
              "update:content": function ($event) {
                return _vm.$set(_vm.currentComponent, "explainText", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }